// extracted by mini-css-extract-plugin
module.exports = {"root":"BZh6DwEh1dtO2SSJT58c"};